import { PropsWithChildren } from 'react';
import { Text } from '@antimatterhq/ui/components/typography';
import { cn } from '@/lib/utils';

export const PageHeader = ({
  pageTitle,
  productTitle = 'Security Lakehouse',
  children,
  className,
}: PropsWithChildren<{
  pageTitle: string;
  productTitle?: string;
  className?: string;
}>) => {
  return (
    <header
      className={cn(
        'flex w-full flex-col bg-white p-4 pb-0 dark:bg-[#11171C]',
        className,
      )}
    >
      <div className="mb-1 flex w-full flex-row items-start justify-between">
        <div className="flex w-fit flex-1">
          <Text size="xl" className="font-bold">
            {pageTitle}
          </Text>
        </div>
        <div
          className="flex w-fit flex-col items-end justify-center gap-0"
          data-testid="title-header-container"
        >
          <h1
            className="text-center text-xl font-bold text-grey-800 dark:text-grey-100"
            data-testid="title-header-title"
          >
            {productTitle}
          </h1>
        </div>
      </div>
      {children}
    </header>
  );
};
